// Import vehicle data from JSON file
import vehicleDataJson from "./vehicleData.json";

// Extract vehicle makes from the JSON data
export const vehicleMakes = Object.keys(vehicleDataJson);

// Process the JSON data to get models in the format we need
const processVehicleModels = () => {
  const processedModels = {};

  for (const make in vehicleDataJson) {
    // Each model is an array where the first element is the model name
    processedModels[make] = vehicleDataJson[make].map((model) => model[0]);
  }

  return processedModels;
};

// Vehicle models data processed from the JSON
export const vehicleModels = processVehicleModels();

// Generate years array (last 30 years)
export const getYears = () => {
  return Array.from({ length: 30 }, (_, i) =>
    (new Date().getFullYear() - i).toString()
  );
};

// Helper function to get models for a selected make
export const getModelsForMake = (make) => {
  return vehicleModels[make] || [];
};
